import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, CheckCircle2 } from 'lucide-react';
const names = ['María', 'Juan', 'Carlos', 'Ana', 'Luis', 'Laura', 'Diego', 'Sofía', 'Valentina', 'Mateo', 'Camila', 'Martín'];
const cities = ['Buenos Aires', 'Santiago', 'Bogotá', 'Lima', 'Ciudad de México', 'Montevideo', 'Córdoba', 'Medellín', 'Guadalajara', 'Rosario', 'Quito'];
export const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1; // 1 to 59 minutes ago
      setCurrentData({
        name: randomName,
        city: randomCity,
        time: `Hace ${randomTime} min`
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 3000);
    // Then show a new popup every 15-25 seconds
    const interval = setInterval(() => {
      showPopup();
    }, Math.floor(Math.random() * 10000) + 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-175" data-mp="i8tr4ss8ccq2">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      type: 'spring',
      bounce: 0.4
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-xl shadow-2xl border border-gray-100 p-4 max-w-sm flex items-start gap-4" data-id="element-176" data-mp="i9uz2ody8j3k">
          <div className="bg-[#F97316]/15 p-2 rounded-full shrink-0" data-id="element-177" data-mp="2aol6yk63qo6f">
            <CheckCircle2 className="text-[#F97316]" size={24} data-id="element-178" data-mp="2aobfes5es8ym" />
          </div>
          <div data-id="element-179" data-mp="2fmcvr5bg9u6e">
            <p className="text-sm text-gray-800" data-id="element-180" data-mp="2fltezrxjdbty">
              <span className="font-bold" data-id="element-181" data-mp="2km7prhqiuzvo">{currentData.name}</span> acaba de
              comprar el Pack Misterios.
            </p>
            <div className="flex items-center gap-1 mt-1 text-xs text-gray-500" data-id="element-182" data-mp="2pkj0rvsjzgfh">
              <MapPin size={12} data-id="element-183" data-mp="1rz4sesxl0v70" />
              <span data-id="element-184" data-mp="1rzwn81jcuow8">Desde {currentData.city}</span>
              <span className="mx-1" data-id="element-185" data-mp="1wwn4gs6wbqj8">•</span>
              <span data-id="element-186" data-mp="1wxg3f6zm5bqt">{currentData.time}</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};